module.exports = __webpack_public_path__ + "img/s03_p02.ab423e58.jpg";